import { useEffect, useState, useRef } from 'react'
import '../../../styles/site.css'
import GetDataSet from '../../../services/data'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faUndo } from '@fortawesome/free-solid-svg-icons'
import { faSync } from '@fortawesome/free-solid-svg-icons'
import Loader from '../../../components/loader'
import IonIcon from '@reacticons/ionicons'
// import { Tooltip } from '@mui/material'
import ListData from './listdataset'
import { getStorebyID } from '../../../services/data'
import { authShopify } from '../../../services/data'
import { UpdateMetaStore } from '../../../services/data'
import useDebounce from '../../../hooks/useDebounce'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { TfiFilter } from 'react-icons/tfi'
import useRippleEffect from '../../../hooks/tripleEffects'
import TrainFilterDropdownPopup from '../../../components/trainfilterdropdownpopup'
import FilterDropDownHook from '../../../hooks/filterdropdownhook'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { format } from 'date-fns'
import SyncLogData from './syncdata'
import StoreUpdateSettings from './storeupdatesettings'
import InfoIconWithToolTip from '../../../util/tooltipwrapper'
import validateJSON from '../../../util/jsonvalidation'
import getViewUrl from '../../../util/generatepageurl'
import console_log from '../../../util/consolelog'
import Cookies from 'js-cookie'
import { useAuth } from '../../../context/logincontext'
import { useStore } from '../../../context/storecontext'
import { useLocation, useParams } from 'react-router-dom'

const Site = () => {
  const chatbot = localStorage.getItem('chatbot') || 'Chatbot'
  const limit = 10
  const itemsPerPage = 10

  const [data, setData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const currentPageRef = useRef(currentPage)

  const [totalPages, setTotalPages] = useState(1)
  const [totalproducts, Settotalproducts] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedItems, setSelectedItems] = useState({})
  const [showDeleteWarning, setShowDeleteWarning] = useState(false)
  const [itemsCount, setItemsCount] = useState(0)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [isListDialogOpen, setIsListDialogOpen] = useState(false)
  const [showfilterdropdown, setshowfilterdropdown] = useState(false)
  // const status = ['Train', 'Untrain']
  // const types = ['Product', 'Collection', 'Page', 'Article']
  const [status, setStatus] = useState('')
  const [type, setType] = useState('')
  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange
  const [fromdate, setfromdate] = useState()
  const [todate, settodate] = useState()
  const [onfiltering, setonfiltering] = useState(false)
  const [error, setError] = useState('')
  const [syncinprogress, Setsyncinprogress] = useState(false)
  const [syncfailed, Setsyncfailed] = useState(false)
  const [syncCompleted, SetsyncCompleted] = useState(false)

  let totalItems = 0

  const { ripple, createRipple } = useRippleEffect()
  const { handleopenClosedropdown, isopenpopup } = FilterDropDownHook()
  const datepickerref = useRef(null)
  const [openstoreupdatesetting, Setopenstoreupdatesetting] = useState(false)
  const POLLING_INTERVAL = 15000
  const pollingRef = useRef(null)
  const [shouldPoll, setShouldPoll] = useState(true)
  const [isProcessing, SetisProcessing] = useState(false)
  const [showSyncMessage, SetshowSyncMessage] = useState(false)
  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const storeid = getStoreIdFromUrl()

  const { userdata } = useAuth()
  // Toggle dialog visibility
  const toggleDialog = () => {
    setIsListDialogOpen(prev => !prev)
  }

  const closefilterpopup = () => {
    handleopenClosedropdown()
  }

  useEffect(() => {
    currentPageRef.current = currentPage
  }, [currentPage])

  // Use the custom debounce hook
  const debouncedSearchTerm = useDebounce(searchTerm, 2000) // 2-second debounce

  const fetchSpecificData = async (page = 1) => {
    window.dispatchEvent(
      new CustomEvent('reloadusecredentials', { detail: true })
    )
    const [start, end] = dateRange

    try {
      const dataSet = new GetDataSet({
        id: '',
        limit: limit,
        page: page,
        type: chatbot,
        status: status,
        shopify_dataset_type: type,
        created_at_from:
          start !== null ? format(new Date(start), 'yyyy-MM-dd') : '',
        created_at_to: end !== null ? format(new Date(end), 'yyyy-MM-dd') : '',
        search: debouncedSearchTerm || '',
        sort: 'createdAt',
        order: 'DESC'
      })
      const chatbotData = debouncedSearchTerm
        ? await dataSet.searchData(debouncedSearchTerm, chatbot)
        : await dataSet.fetchData()

      // if (chatbotData.data.length > 0) {
      //   SetsyncCompleted(true)
      // }

      if (chatbotData.success) {
        setData(chatbotData.data)
        totalItems = chatbotData.pagination?.total || 0
        Settotalproducts(chatbotData.pagination?.total || 0)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
      } else {
        setData([])
        setTotalPages(1)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    checkTrainingStatus()
  }, [])

  const checkTrainingStatus = async () => {
    try {
      let allData = []
      let page = 1
      let limit = 1000
      let total = 0

      do {
        const response = await new GetDataSet({
          limit,
          page
        }).fetchData()

        console_log(`Page ${page}:`, response)

        if (!Array.isArray(response?.data) || response.data.length === 0) {
          break
        }

        allData = [...allData, ...response.data]
        total = response?.pagination.total || allData.length

        page++
      } while (allData.length < total)
      console_log(allData)
      // Once all pages are fetched
      if (allData.length === 0) {
        SetsyncCompleted(false)
        SetisProcessing(true)
        stopPolling()
        return
      }

      const flatData = allData.flat(Infinity).filter(Boolean)

      // Now run the check
      const isProcessing = flatData.some(item => item.training_processing === 1)
      if (isProcessing) {
        startPolling()
        fetchSpecificData(currentPageRef.current)
        Setsyncinprogress(true)
        SetshowSyncMessage(true)
      } else {
        SetsyncCompleted(true)
        Setsyncinprogress(false)
        stopPolling()
      }
    } catch (err) {
      Setsyncfailed(true)
      Setsyncinprogress(false)
      SetsyncCompleted(false)
      console.error('Polling error:', err)
      stopPolling()
    }
  }

  const startPolling = () => {
    if (pollingRef.current) return // Prevent duplicate intervals

    setShouldPoll(true)
    SetisProcessing(true)
    checkTrainingStatus()
    pollingRef.current = setInterval(checkTrainingStatus, POLLING_INTERVAL)
  }

  const stopPolling = () => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current)
      pollingRef.current = null
    }

    Setsyncinprogress(false)
    setShouldPoll(false)
    SetisProcessing(false)
    fetchSpecificData(currentPageRef.current)
    setTimeout(() => {
      SetsyncCompleted(false) // hide it after 20s
    }, 20000)
  }

  useEffect(() => {
    return () => {
      stopPolling()
    }
  }, [])

  useEffect(() => {
    const handleStartPolling = async event => {
      if (event.detail) {
        try {
          const response = await new GetDataSet({
            limit: 1000
          }).fetchData()

          const isProcessing = response.data.some(
            item => item.training_processing === 1
          )
          console.log(isProcessing)
          if (isProcessing) {
            window.location.reload()
            fetchSpecificData(currentPageRef.current)
            Setsyncinprogress(true)
            SetshowSyncMessage(true)
            console.log('Start the polling')
            startPolling()
          }
        } catch (error) {
          console.error('Error fetching dataset:', error)
        }
      }
    }

    window.addEventListener('startpolling', handleStartPolling)
    return () => {
      window.removeEventListener('startpolling', handleStartPolling)
    }
  }, [])

  // Fetch data when searchTerm changes
  useEffect(() => {
    setCurrentPage(1) // Reset to the first page when search term changes
  }, [debouncedSearchTerm])

  // Fetch data when currentPage or searchTerm changes
  useEffect(() => {
    fetchSpecificData(currentPage)
  }, [debouncedSearchTerm, currentPage, limit])

  // Handle pagination
  const handlePageChange = direction => {
    setCurrentPage(prevPage => {
      if (direction === 'next' && prevPage < totalPages) {
        return prevPage + 1
      } else if (direction === 'prev' && prevPage > 1) {
        return prevPage - 1
      }
      return prevPage // No change if out of bounds
    })
  }

  const handlefilterSubmit = e => {
    console.log(
      'Filter Form Submitted',
      status,
      type,
      dateRange[0],
      dateRange[1],
      fromdate,
      todate
    )
    if (dateRange[0] !== null) {
      if (!dateRange[0]) {
        setError('start dates required.')
        return
      }

      if (!dateRange[1]) {
        setError('end dates required.')
        return
      }
    }
    setError('')

    if (dateRange[0] > dateRange[1]) {
      setError('Start date cannot be after end date.')
      return
    }

    setonfiltering(true)

    if (dateRange[0] !== null && dateRange[1] !== null) {
      // const [start, end] = dateRange
      // const formattedStartDate = format(new Date(start), 'yyyy-MM-dd')
      // const formattedEndDate = format(new Date(end), 'yyyy-MM-dd')
      // setfromdate(formattedStartDate)
      // settodate(formattedEndDate)

      fetchSpecificData()
      console.log('pass')
      handleopenClosedropdown()
    } else {
      if (
        status === '' &&
        type === '' &&
        dateRange[0] === null &&
        dateRange[1] === null
      ) {
        setonfiltering(false)
      } else {
        setonfiltering(true)
        console.log('no pass')
      }

      fetchSpecificData()
      handleopenClosedropdown()
    }
    //  if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1] || status !== "" || type !== "") {
    //       const [start, end] = dateRange;

    //       const formattedStartDate = format(new Date(start), 'yyyy-MM-dd');
    //       const formattedEndDate = format(new Date(end), 'yyyy-MM-dd');

    //       console.log('Formatted Start Date:', formattedStartDate);
    //       console.log('Formatted End Date:', formattedEndDate);

    //       setfromdate(formattedStartDate)
    //       settodate(formattedEndDate)
    //       fetchSpecificData()
    //     }else{
    //       fetchSpecificData()
    //     }
    // Handle form submission logic here
  }

  // Use useEffect to monitor when all filters are actually cleared
  // useEffect(() => {
  //   if (
  //     status === '' &&
  //     type === '' &&
  //     dateRange[0] === null &&
  //     dateRange[1] === null &&
  //     fromdate === '' &&
  //     todate === ''
  //   ) {
  //     console.log("Yes, it's empty")
  //     fetchSpecificData()
  //   } else {

  //     console.log('No, one is not empty')
  //     fetchSpecificData()
  //   }
  // }, [])

  const handleclearfilter = () => {
    setStatus('')
    setType('')
    setDateRange([null, null])
    setfromdate('')
    settodate('')

    // fetchSpecificData()
    // handleopenClosedropdown()
  }

  // Handle checkbox toggle for selection
  const handleCheckboxChange = id => {
    setSelectedItems(prev => {
      const updatedSelection = { ...prev, [id]: !prev[id] }
      setShowDeleteWarning(
        Object.values(updatedSelection).some(isSelected => isSelected)
      )
      return updatedSelection
    })
  }

  useEffect(() => {
    const count = Object.values(selectedItems).filter(
      isSelected => isSelected
    ).length
    setItemsCount(count)
    setShowDeleteWarning(count > 0)
  }, [selectedItems])

  // Handle deleting multiple items
  const handleYesButtonClick = async () => {
    const idsToDelete = Object.keys(selectedItems).filter(
      id => selectedItems[id]
    )

    if (idsToDelete.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      const deleteResponse = await new GetDataSet().multipleDelete(idsToDelete)

      if (deleteResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)

        fetchSpecificData(currentPage) // Refresh data after deletion
        toast.success('Items deleted successfully.', {
          position: 'bottom-center'
        })
        setDialogOpen(false)
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error deleting items:', error)
      toast.error('There was an error deleting the item.', {
        position: 'bottom-center'
      })
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  // Handle deleting a single item
  const handledeletesingledata = async datasetID => {
    try {
      const res = await new GetDataSet().singleDelete(datasetID)

      if (res.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)
        fetchSpecificData() // Refresh data after deletion
        toast.success('Item deleted successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Error deleting the item.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error deleting the item:', error)
      toast.error('There was an error deleting the item.', {
        position: 'bottom-center'
      })
    }
  }

  // Since the backend provides paginated data directly, use `data` as is
  const currentData = data

  // Check if all items on the current page are selected
  const allSelected = currentData.every(item => selectedItems[item.dataset_id])

  // Use the total count from the backend or data.length for the current page
  const startItem = (currentPage - 1) * itemsPerPage + 1
  const endItem = startItem + currentData.length - 1
  totalItems = itemsCount // Use `itemsCount` from the backend's total count

  const handleuntraindataset = async () => {
    const idsToTrain = Object.keys(selectedItems).filter(
      id => selectedItems[id]
    )
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      // toast.info('Untraining in-progress', {
      //   position: 'bottom-center'
      // })
      const untrainResponse = await new GetDataSet().setUntrained(idsToTrain)

      if (untrainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)
        fetchSpecificData(currentPage) // Refresh data after untrain
        toast.success('Item untrained successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error untrain items:', error)
      toast.error('There was an error untraining the item.', {
        position: 'bottom-center'
      })
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  const handleTrainDataset = async () => {
    const idsToTrain = Object.keys(selectedItems).filter(
      id => selectedItems[id]
    )
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      toast.info('Training process in-progress', {
        position: 'bottom-center'
      })
      const trainResponse = await new GetDataSet().setTrained(idsToTrain)

      if (trainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)

        fetchSpecificData(currentPage) // Refresh data after training
        toast.success('Item processed successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error training items:', error)
      toast.error('There was an error while processing.', {
        position: 'bottom-center'
      })
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  const handleuntraindatasetflashoff = async id => {
    const idsToTrain = [id]
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      // toast.info('Untraining in-progress', {
      //   position: 'bottom-center'
      // })
      const trainResponse = await new GetDataSet().setUntrained(idsToTrain)

      if (trainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)
        fetchSpecificData(currentPage) // Refresh data after training
        toast.success('Item untrained successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error training items:', error)
      toast.error('There was an error while processing.', {
        position: 'bottom-center'
      })
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }
  const handleinstall = async (error, idsToTrain) => {
    // console.error('Error training items:', error)
    // toast.error(error.message, {
    //   position: 'bottom-center'
    // })

    const message = error.message

    const hasKeywords =
      message.toLowerCase().includes('authentication') &&
      message.toLowerCase().includes('shopify')

    if (hasKeywords) {
      const store_id = storeid
      const store = await getStorebyID(store_id)
      const baseURL = store.data.name
      const fullURL = `${baseURL}.myshopify.com`
      const shopifysessionresync = await authShopify(
        fullURL.replace('https://', '').replace(/\/$/, '')
      )
      window.open(shopifysessionresync, '_blank', 'width=600,height=600')

      const data = {
        name: store.data.name,
        type: 'shopify',
        user_id: validateJSON(userdata),
        // user_id: validateJSON(userdata).id,
        // user_id: validateJSON(Cookies.get('user')).id,
        meta: validateJSON(localStorage.getItem('shopifySession'))
      }

      const res = await UpdateMetaStore(data, store_id) // Await the async post data request
      console.log(res)
      if (res.success) {
        try {
          toast.info('Training process in-progress', {
            position: 'bottom-center'
          })
          const trainResponse = await new GetDataSet().setTrained(idsToTrain)

          if (trainResponse.success) {
            const deleteEvent = new CustomEvent('datasetDeleted', {
              detail: true
            })
            window.dispatchEvent(deleteEvent)
            // fetchSpecificData()
            localStorage.removeItem('shopifySession')
            fetchSpecificData() // Refresh data after training
            toast.success('Item processed successfully.', {
              position: 'bottom-center'
            })
          } else {
            toast.error('Process failed due to error.', {
              position: 'bottom-center'
            })
          }
        } catch (error) {
          // console.error('Error training items:', error)
          toast.error(error.message, {
            position: 'bottom-center'
          })
        } finally {
          setSelectedItems({})
          setShowDeleteWarning(false)
        }
      } else {
        console.log('no')
      }

      // Output: https://steppingedge-theme-prototype-1.myshopify.com
      // const shopify = new Shopify(store.shop, store.access_token)
      // const res = await shopify.getProducts()
      // const store_id = localStorage.getItem('store_id')
      // const store = await getStorebyID(store_id)
      // console.log(store)
    }
  }
  const handleuntraindatasetflashon = async id => {
    const idsToTrain = [id]
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }

    try {
      toast.info('Training process in-progress', {
        position: 'bottom-center'
      })
      const trainResponse = await new GetDataSet().setTrained(idsToTrain)

      if (trainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)
        localStorage.removeItem('shopifySession')
        fetchSpecificData(currentPage) // Refresh data after training
        toast.success('Item processed successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      // console.error('Error training items:', error)
      // toast.error(error.message, {
      //   position: 'bottom-center'
      // })
      handleinstall(error, idsToTrain)
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  const handleresync = async id => {
    const idsToTrain = [id]
    if (idsToTrain.length === 0) {
      setShowDeleteWarning(false)
      return
    }
    toast.info('Re-Sync process in-progress', {
      position: 'bottom-center'
    })
    try {
      const trainResponse = await new GetDataSet().setTrained(idsToTrain)

      if (trainResponse.success) {
        const deleteEvent = new CustomEvent('datasetDeleted', { detail: true })
        window.dispatchEvent(deleteEvent)

        fetchSpecificData(currentPage) // Refresh data after training
        localStorage.removeItem('shopifySession')
        toast.success('Product Re-Sync successfully.', {
          position: 'bottom-center'
        })
      } else {
        toast.error('Process failed due to error.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      handleinstall(error, idsToTrain)
    } finally {
      setSelectedItems({})
      setShowDeleteWarning(false)
    }
  }

  const openMessage = () => {
    setDialogOpen(true)
  }

  const handleNoButtonClick = () => {
    setDialogOpen(false)
  }

  const maindialogclose = () => {
    setIsListDialogOpen(false)
  }

  useEffect(() => {
    const handlelistmodalclose = () => {
      setIsListDialogOpen(false)
    }

    window.addEventListener('listmodalclose', handlelistmodalclose)

    return () => {
      window.removeEventListener('listmodalclose', handlelistmodalclose)
    }
  })

  return (
    <>
      {dialogOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
          <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] mx-5 h-[240px] p-6 border-[1.6px] border-[#FFFFFF]  shadow[-1px_0px_0px_0px_inset]'>
            <div className='block'>
              <div className='w-full flex justify-end items-start '>
                <svg
                  onClick={handleNoButtonClick}
                  width='26'
                  height='26'
                  className='cursor-pointer'
                  viewBox='0 0 26 26'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M7.88702 6.73798C7.56972 6.42067 7.05528 6.42067 6.73798 6.73798C6.42067 7.05528 6.42067 7.56972 6.73798 7.88702L11.851 13L6.73798 18.113C6.42067 18.4303 6.42067 18.9447 6.73798 19.262C7.05528 19.5793 7.56972 19.5793 7.88702 19.262L13 14.149L18.113 19.262C18.4303 19.5793 18.9447 19.5793 19.262 19.262C19.5793 18.9447 19.5793 18.4303 19.262 18.113L14.149 13L19.262 7.88702C19.5793 7.56972 19.5793 7.05528 19.262 6.73798C18.9447 6.42067 18.4303 6.42067 18.113 6.73798L13 11.851L7.88702 6.73798Z'
                    fill='#373737'
                  />
                </svg>
              </div>
              <div className=' mt-2 flex flex-col items-center justify-center gap-3'>
                <p className='font-[800] text-[20px] leading-[38.25px] text-[#252530]'>
                  Delete
                </p>
                <p className='font-[400] text-[16px] leading-[21px]'>
                  Do you want to delete selected items?
                </p>
                <div className='flex mt-4 gap-4'>
                  <button
                    onClick={handleNoButtonClick}
                    className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleYesButtonClick}
                    className='bg-[#E22400] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className=' gap-2 overflow-x-auto md:overflow-x-visible scrollbar-hide md:flex  block  justify-between border-b-[1px] pt-7 pl-3 pr-3 pb-7'>
        <div className='w-full'>
          <div className='flex items-center gap-1'>
            <h2 className='font-bold text-[18px] cursor-pointer'>
              {chatbot === 'shopify'
                ? 'Shopify'
                : chatbot === 'website'
                ? 'Website'
                : chatbot === 'magento'
                ? 'Magento'
                : ''}
            </h2>

            <InfoIconWithToolTip
              content={
                chatbot === 'shopify'
                  ? "Your bot was trained using your store's content including product names, descriptions, prices, images, collections, pages, and blog posts."
                  : chatbot === 'website'
                  ? 'Your bot was powered by your store’s real data, products, pages, and blogs, to deliver accurate, real-time customer support.'
                  : chatbot === 'magento'
                  ? 'Magento chatbot that uses your store’s data to deliver personalized, real-time support and boost conversions.'
                  : ''
              }
            />
          </div>
          <div className='flex  items-center gap-2 w-full'>
            <div className='font-[500] text-[14px] leading-[24px] flex'>
              <p> Dataset</p> <p> ({totalproducts}) </p>
            </div>

            {syncinprogress && showSyncMessage && !syncCompleted && (
              <div className='flex items-center gap-1 w-full'>
                <span className='relative flex size-3'>
                  <span className='absolute inline-flex h-full w-full animate-ping rounded-full bg-[#EEA23E] opacity-75'></span>
                  <span className='relative inline-flex size-3 rounded-full bg-[#EEA23E]'></span>
                </span>
                <p className='text-sm text-gray-700 w-full'>Sync in progress</p>
              </div>
            )}

            {!syncinprogress && syncCompleted && showSyncMessage && (
              <div className='flex items-center gap-2 w-full'>
                <span className='relative flex size-3'>
                  <span className='absolute inline-flex h-full w-full animate-ping rounded-full bg-[#2D8A39] opacity-75'></span>
                  <span className='relative inline-flex size-3 rounded-full bg-[#2D8A39]'></span>
                </span>
                <p className='text-sm text-gray-700'>Sync is completed</p>
              </div>
            )}

            {!syncinprogress &&
              !syncCompleted &&
              syncfailed &&
              showSyncMessage && (
                <div className='flex items-center gap-2'>
                  <span className='relative flex size-3'>
                    <span className='absolute inline-flex h-full w-full animate-ping rounded-full bg-[#ff0000] opacity-75'></span>
                    <span className='relative inline-flex size-3 rounded-full bg-[#ff0000]'></span>
                  </span>
                  <p className='text-sm text-gray-700'>
                    Sync failed. Please refresh the page.
                  </p>
                </div>
              )}
          </div>
        </div>
        <div className=''>
          <div className='flex flex-col mt-2 gap-3 md:flex-row items-center justify-end relative w-full  '>
            {/* <button className='flex items-center justify-center gap-1 text-white bg-black px-5   rounded-[5px] h-[29px] font-[600] text-[11.5px] '>
            Reinstall <FontAwesomeIcon icon={faUndo} />
          </button> */}

            <div className='relative w-full flex gap-3 justify-end items-center'>
              <div className='relative'>
                <div className='relative w-full Filter1'>
                  <button
                    // data-tooltip-id={'my-tooltip'}
                    // data-tooltip-content={'filter'}
                    // data-tooltip-place={'top'}
                    onClick={event => {
                      createRipple(event)
                      handleopenClosedropdown()
                    }}
                    className={`relative bg-[#f4f4f4] py-[11px] px-[11px] rounded-[8px] border-[0.5px] cursor-pointer 
      hover:bg-gray-200 transition-all  ${isopenpopup && 'bg-gray-200'}`}
                  >
                    <TfiFilter size={16} />
                    {ripple.map(({ x, y, id }) => (
                      <span
                        key={id}
                        className='absolute block bg-white opacity-100 rounded-full animate-ripple'
                        style={{
                          top: y,
                          left: x,
                          width: '20px',
                          height: '20px',
                          transform: 'translate(50%, 50%)'
                        }}
                      ></span>
                    ))}
                  </button>
                  {onfiltering && (
                    <span className=' absolute right-[0.1px] top-[-1px] bg-green-400 w-2 h-2 rounded'></span>
                  )}
                </div>
                {isopenpopup && (
                  <TrainFilterDropdownPopup
                    isopenpopup={closefilterpopup}
                    clearbtn={handleclearfilter}
                    fields={[
                      // Custom Dropdown
                      <div className='flex relative w-full '>
                        <div className='flex flex-col w-full justify-start'>
                          <p className='text-[#7A7D9C] text-[14px] mb-1'>
                            Status
                          </p>
                          <select
                            name='status'
                            value={status}
                            onChange={e => {
                              setStatus(e.target.value)
                            }}
                            className='w-full cursor-pointer border-[1px] border-[#BFC4D7] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none appearance-none '
                          >
                            <option value=''>---</option>
                            <option value='active'>Trained</option>
                            <option value='inactive'>UnTrained</option>
                          </select>
                          <IonIcon
                            name='chevron-down'
                            className='absolute right-2 top-[58%] text-gray-500 cursor-pointer pointer-events-none'
                          />
                        </div>
                      </div>,
                      <div className='relative w-full'>
                        <div className='flex flex-col w-full justify-start'>
                          <p className='text-[#7A7D9C] text-[14px] mb-1'>
                            Dataset Type
                          </p>
                          <select
                            name='type'
                            value={type}
                            onChange={e => setType(e.target.value)}
                            className='w-full cursor-pointer border-[1px] border-[#BFC4D7] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none appearance-none'
                          >
                            <option value=''>---</option>
                            <option value='Product'>Product</option>
                            <option value='Collection'>Collection</option>
                            <option value='Page'>Page</option>
                            <option value='Article'>Article</option>
                          </select>
                        </div>

                        <IonIcon
                          name='chevron-down'
                          className='absolute right-2 top-[58%] text-gray-500 cursor-pointer pointer-events-none'
                        />
                      </div>,
                      // Custom Date Picker
                      <div className='relative flex cursor-pointer w-full'>
                        <div className='flex flex-col w-full justify-start'>
                          <p className='text-[#7A7D9C] text-[14px] mb-1'>
                            Date Range
                          </p>
                          <DatePicker
                            ref={datepickerref}
                            selected={startDate}
                            onChange={update => setDateRange(update)}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            dateFormat='yyyy-MM-dd'
                            autoComplete='off'
                            name='daterange'
                            className='w-full border-[1px] border-[#BFC4D7] placeholder:text-[#ABADB5] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none'
                          />
                          {error && (
                            <p className='text-red-500 text-sm absolute bottom-[-18px]'>
                              {error}
                            </p>
                          )}
                        </div>
                        <IonIcon
                          name='calendar-outline'
                          className='absolute right-2 top-[58%] text-gray-500 cursor-pointer '
                          onClick={() => datepickerref.current.setOpen(true)} // Open DatePicker programmatically
                        />
                      </div>
                    ]}
                    onsubmit={handlefilterSubmit}
                  />
                )}
              </div>
              <input
                type='text'
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className='focus:outline-none w-[194px]  h-[41px] rounded-[39px] gap-[129px] border-[0.5px] pl-[40px] pt-[10px] pr-[40px] pb-[12px] bg-[#F4F4F4] placeholder:text-[#565656] placeholder:text-[12px] text-[14px]'
                placeholder='Search here'
              />
              <svg
                width='16'
                height='15'
                className='absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer'
                viewBox='0 0 16 15'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M15.0555 13.3145L11.7477 10.0066C12.544 8.94645 12.9739 7.65598 12.9725 6.33C12.9725 2.94305 10.217 0.1875 6.83 0.1875C3.44305 0.1875 0.6875 2.94305 0.6875 6.33C0.6875 9.71695 3.44305 12.4725 6.83 12.4725C8.15598 12.4739 9.44645 12.044 10.5066 11.2477L13.8145 14.5555C13.9819 14.7052 14.2003 14.7851 14.4248 14.7788C14.6493 14.7725 14.8629 14.6805 15.0217 14.5217C15.1805 14.3629 15.2725 14.1493 15.2788 13.9248C15.2851 13.7003 15.2052 13.4819 15.0555 13.3145ZM2.4425 6.33C2.4425 5.46223 2.69982 4.61396 3.18193 3.89244C3.66403 3.17092 4.34927 2.60856 5.15098 2.27648C5.95269 1.9444 6.83487 1.85751 7.68596 2.0268C8.53705 2.1961 9.31883 2.61397 9.93243 3.22757C10.546 3.84117 10.9639 4.62295 11.1332 5.47404C11.3025 6.32513 11.2156 7.20731 10.8835 8.00902C10.5514 8.81073 9.98909 9.49597 9.26756 9.97807C8.54604 10.4602 7.69777 10.7175 6.83 10.7175C5.66679 10.7161 4.55162 10.2534 3.72911 9.43089C2.9066 8.60838 2.4439 7.49321 2.4425 6.33Z'
                  fill='#0F062C'
                  fillOpacity='0.7'
                />
              </svg>
            </div>
            <button
              className={`mt-4 md:mt-0 px-4 sync py-2  w-full md:w-[140px] flex justify-center items-center text-white rounded-full text-[14px] ${
                isProcessing
                  ? 'bg-gray-400 cursor-not-allowed '
                  : 'bg-[#000000]'
              } `}
              disabled={isProcessing}
              onClick={toggleDialog}
              data-tooltip-id={'my-tooltip'}
              data-tooltip-content={
                isProcessing === true
                  ? 'A sync is already in progress. Please wait for it to complete.'
                  : chatbot === 'shopify'
                  ? 'Clicking the Sync button refreshes the chatbot with the latest data from your Shopify store, including products, collections, pages, and blogs ensuring real-time, accurate responses for improved customer support.'
                  : chatbot === 'website'
                  ? ' Clicking the Sync button updates the chatbot with the most recent content from your website, including products, collections, pages, and blogs, to deliver up-to-date and reliable customer responses.'
                  : ' Clicking the Sync button imports the latest products, categories, CMS pages, and blog posts from your Magento store, allowing the chatbot to provide accurate and timely responses that boost customer interaction.'
              }
              data-tooltip-place={'top'}
            >
              <p className='text-[11px] mt-1 mr-2 font-[700]'>
                {' '}
                <FontAwesomeIcon icon={faSync} />{' '}
              </p>
              <p className='mr-2 text-[12px] font-[700] leading-5'> Sync </p>
            </button>
            {chatbot !== 'shopify' && (
              <button
                onClick={() => {
                  Setopenstoreupdatesetting(true)
                }}
                className={`flex justify-center items-center ${
                  chatbot === 'website'
                    ? 'tooltipwalkthrough-website'
                    : 'tooltipwalkthrough-magento'
                }`}
              >
                <IonIcon name='settings-outline' className='text-[25px]' />
              </button>
            )}
            {openstoreupdatesetting && (
              <StoreUpdateSettings
                close={() => {
                  Setopenstoreupdatesetting(false)
                }}
                storetype={chatbot}
              />
            )}
            {isListDialogOpen && (
              <>
                {/* <ListData /> */}
                <SyncLogData
                  maindialogclose={maindialogclose}
                  success={() => fetchSpecificData()}
                  closepopup={() => setIsListDialogOpen(false)}
                  isProcessing={isProcessing}
                />
              </>
            )}
          </div>
        </div>
      </div>
      {showDeleteWarning && (
        <div
          className={`transition-all duration-500 ease-in-out transform overflow-x-auto ${
            showDeleteWarning
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 -translate-y-4'
          } flex justify-between pt-2 pb-2 bg-[#232328] items-center pl-3 pr-3 border-b-[1px]`}
        >
          <div className='flex'>
            <div className='w-[195px] h-[35px] flex items-center text-white rounded-[8px]'>
              <FontAwesomeIcon
                icon={faCheck}
                className='text-white mr-2 text-[12px]'
              />
              <span className='text-[12px] font-semibold'>{itemsCount}</span>
              <p className='text-[12px] font-semibold ml-2'>selected items</p>
            </div>
          </div>
          <div className='flex gap-4 items-center'>
            <div
              onClick={openMessage}
              className='w-[32px] h-[32px] flex items-center justify-center bg-red-600 rounded-[8px] cursor-pointer'
            >
              <svg
                width='32'
                height='33'
                viewBox='0 0 34 35'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M15.7485 11.5C15.7159 11.4999 15.6835 11.5063 15.6533 11.5187C15.6231 11.5312 15.5957 11.5495 15.5726 11.5726C15.5495 11.5957 15.5312 11.6231 15.5187 11.6533C15.5063 11.6835 15.4999 11.7159 15.5 11.7485L15.5 11.75V12.5H18.5V11.75L18.5 11.7485C18.5001 11.7159 18.4937 11.6835 18.4813 11.6533C18.4688 11.6231 18.4505 11.5957 18.4274 11.5726C18.4043 11.5495 18.3769 11.5312 18.3467 11.5187C18.3165 11.5063 18.2841 11.4999 18.2515 11.5L18.25 11.5H15.75L15.7485 11.5ZM13.0322 13.5L13.624 22.9688C13.6241 22.9707 13.6242 22.9725 13.6243 22.9743C13.6416 23.3108 13.865 23.5 14.125 23.5H19.875C20.1324 23.5 20.3548 23.3151 20.3759 22.9695L20.9678 13.5H13.0322ZM21.4954 12.5H19.5V11.7507C19.5004 11.5865 19.4683 11.4238 19.4057 11.272C19.343 11.1199 19.2508 10.9818 19.1345 10.8655C19.0182 10.7492 18.8801 10.657 18.728 10.5943C18.5762 10.5317 18.4136 10.4996 18.2494 10.5H15.7506C15.5864 10.4996 15.4238 10.5317 15.272 10.5943C15.1199 10.657 14.9818 10.7492 14.8655 10.8655C14.7492 10.9818 14.657 11.1199 14.5943 11.272C14.5317 11.4238 14.4996 11.5864 14.5 11.7506V12.5H12.5046C12.5019 12.5 12.4991 12.5 12.4963 12.5H11.5C11.2239 12.5 11 12.7239 11 13C11 13.2761 11.2239 13.5 11.5 13.5H12.0303L12.6258 23.0287C12.6693 23.8464 13.286 24.5 14.125 24.5H19.875C20.722 24.5 21.3245 23.8406 21.3741 23.0306C21.3741 23.0306 21.3741 23.0305 21.3741 23.0305L21.9697 13.5H22.5C22.7761 13.5 23 13.2761 23 13C23 12.7239 22.7761 12.5 22.5 12.5H21.5037C21.5009 12.5 21.4981 12.5 21.4954 12.5ZM14.7322 14.5003C15.0081 14.4905 15.2398 14.7062 15.2497 14.9822L15.4997 21.9822C15.5095 22.2581 15.2938 22.4898 15.0178 22.4997C14.7419 22.5095 14.5102 22.2938 14.5003 22.0178L14.2503 15.0178C14.2405 14.7419 14.4562 14.5102 14.7322 14.5003ZM19.2678 14.5003C19.5438 14.5102 19.7595 14.7419 19.7497 15.0178L19.4997 22.0178C19.4898 22.2938 19.2581 22.5095 18.9822 22.4997C18.7062 22.4898 18.4905 22.2581 18.5003 21.9822L18.7503 14.9822C18.7602 14.7062 18.9919 14.4905 19.2678 14.5003ZM17 14.5C17.2761 14.5 17.5 14.7239 17.5 15V22C17.5 22.2761 17.2761 22.5 17 22.5C16.7239 22.5 16.5 22.2761 16.5 22V15C16.5 14.7239 16.7239 14.5 17 14.5Z'
                  fill='#FFF'
                />
              </svg>
            </div>
            <div className='flex justify-center items-center gap-2'>
              <button
                data-tooltip-id={'my-tooltip'}
                data-tooltip-content={
                  'These have been used to teach the AI, so it understands them.'
                }
                data-tooltip-place={'top'}
                onClick={handleTrainDataset}
                className='hover:bg-[#7C50DD] bg-white w-[69px] rounded-[5px] h-[29px] font-[600] text-[11.5px] text-black hover:text-white'
              >
                Train
              </button>
              <button
                data-tooltip-id={'my-tooltip'}
                data-tooltip-content={'The AI hasn’t worked with these yet.'}
                data-tooltip-place={'top'}
                onClick={handleuntraindataset}
                className='hover:bg-[#7C50DD] bg-white w-[69px] rounded-[5px] h-[29px] font-[600] text-[11.5px] text-black hover:text-white'
              >
                UnTrain
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      <div className=''>
        <div className='overflow-x-auto'>
          <table className='min-w-full table-auto'>
            <thead>
              <tr className='border-b-[1px]'>
                <th className='border-none p-3 text-left font-extrabold text-[14px] leading-[24px]'>
                  <div className='flex justify-start items-center'>
                    <input
                      type='checkbox'
                      className='mr-2 border-2 border-[#7C50DD] rounded cursor-pointer checked:bg-[#7C50DD] checked:border-[#7C50DD] focus:outline-none'
                      onChange={() => {
                        const newSelectedItems = currentData.reduce(
                          (acc, item) => {
                            acc[item.dataset_id] = !allSelected
                            return acc
                          },
                          {}
                        )
                        setSelectedItems(prevSelectedItems => ({
                          ...prevSelectedItems,
                          ...newSelectedItems
                        }))
                        setShowDeleteWarning(!allSelected)
                      }}
                      checked={allSelected}
                    />
                    Title
                  </div>
                </th>
                <th className='border-none  p-3 text-left font-extrabold text-[14px] leading-[24px]'>
                  <p className='createddate inline-flex'>Created Date</p>
                </th>
                <th className='border-none  p-3 text-left font-extrabold text-[14px] leading-[24px]'>
                  <p className='status inline-flex'>Status</p>
                </th>
                <th className='border-none  p-3 text-left font-extrabold text-[14px] leading-[24px] '>
                  <p className='action inline-flex'>Action</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan='4' className='text-center py-4'>
                    {`Please click on sync button to train your chatbot with ${chatbot} content.`}
                  </td>
                </tr>
              ) : (
                currentData.map(item => (
                  <tr key={item.dataset_id} className='border-b-[1px]'>
                    {/* Title */}
                    <td className='border-none p-3 font-[500] text-[11.5px] text-[#252C32] max-w-[490px]'>
                      <div className='flex justify-start items-center'>
                        <input
                          type='checkbox'
                          className='mr-2'
                          checked={selectedItems[item.dataset_id] || false}
                          onChange={() => handleCheckboxChange(item.dataset_id)}
                        />
                        <p className='mt-[0.4%]'>{item.title}</p>
                      </div>
                    </td>

                    {/* Created Date */}
                    <td className='border-none p-3 font-[500] text-[11.5px] text-[#252C32]'>
                      {new Date(item.createdAt).toLocaleString('en-US', {
                        timeZone: 'UTC'
                      })}
                    </td>

                    {/* Status */}
                    <td className='border-none p-3 font-[500] text-[11.5px] text-[#252C32]'>
                      {item.training_processing === 1 ? (
                        <div className='inline-flex items-center h-[24px] px-2 bg-[#FFF8EB] rounded-[5px]'>
                          <div className='w-[4px] h-[4px] bg-[#EEA23E] rounded-full'></div>
                          <p className='ml-1 text-[11.5px] text-[#000000]'>
                            In Progress
                          </p>
                        </div>
                      ) : item.training_processing === -1 ? (
                        <div className='inline-flex items-center h-[24px] px-2 bg-[#FFCDD2] rounded-[5px]'>
                          <div className='w-[4px] h-[4px] bg-[#ff0000] rounded-full'></div>
                          <p className='ml-1 text-[11.5px] text-[#000000]'>
                            Failed
                          </p>
                        </div>
                      ) : item.status === 'active' ? (
                        <div className='inline-flex items-center h-[24px] px-2 bg-[#F0FAF0] rounded-[5px]'>
                          <div className='w-[4px] h-[4px] bg-[#2D8A39] rounded-full'></div>
                          <p className='ml-1 text-[11.5px] text-[#2D8A39]'>
                            Trained
                          </p>
                        </div>
                      ) : (
                        <div className='inline-flex items-center h-[24px] px-2 bg-[#FFF8EB] rounded-[5px]'>
                          <div className='w-[4px] h-[4px] bg-[#EEA23E] rounded-full'></div>
                          <p className='ml-1 text-[11.5px] text-[#000000]'>
                            Untrained
                          </p>
                        </div>
                      )}
                    </td>

                    {/* Action */}
                    <td className='border-none p-3 font-[500] text-[11.5px] text-[#252C32]'>
                      <div className='flex gap-2'>
                        {item.training_processing === 1 ? (
                          <Loader size={24} />
                        ) : item.training_processing === -1 ||
                          item.status === 'inactive' ? (
                          <button
                            data-tooltip-id='my-tooltip'
                            data-tooltip-content='train'
                            data-tooltip-place='top'
                            className='text-[18px] flex items-center'
                            onClick={() =>
                              handleuntraindatasetflashon(item.dataset_id)
                            }
                          >
                            <IonIcon name='flash-outline' />
                          </button>
                        ) : item.status === 'active' ? (
                          <button
                            data-tooltip-id='my-tooltip'
                            data-tooltip-content='untrain'
                            data-tooltip-place='top'
                            className='text-[18px] flex items-center'
                            onClick={() =>
                              handleuntraindatasetflashoff(item.dataset_id)
                            }
                          >
                            <IonIcon name='flash-off-outline' />
                          </button>
                        ) : null}

                        {/* Re-sync always available */}
                        <button
                          data-tooltip-id='my-tooltip'
                          data-tooltip-content='re-sync'
                          data-tooltip-place='top'
                          className='text-[18px] flex items-center'
                          onClick={() => handleresync(item.dataset_id)}
                        >
                          <IonIcon name='sync-outline' />
                        </button>

                        {/* View Button */}
                        <a
                          href={getViewUrl(
                            item.meta,
                            validateJSON(
                              localStorage.getItem('storedata') || '{}'
                            )
                          )}
                          className='flex items-center text-black'
                          target='_blank'
                          rel='noreferrer'
                        >
                          <button className='text-[18px] flex items-center'>
                            <IonIcon name='eye-outline' />
                          </button>
                        </a>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className=''>
          <div className='flex justify-between items-center p-3'>
            <span className='font-[600] text-[12px] '>
              {currentData.length === 0 ? '0' : startItem} - {endItem} of{' '}
              {totalproducts}
            </span>

            <div className='flex items-center'>
              <button
                onClick={() => handlePageChange('prev')}
                disabled={currentPage === 1}
                className=' p-2 '
              >
                &lt; {/* Left Arrow */}
              </button>
              <span className='mx-2 font-[600] text-[12px]'>
                Page {currentData.length === 0 ? '0' : currentPage} of{' '}
                {totalPages}
              </span>
              <button
                onClick={() => handlePageChange('next')}
                disabled={currentPage === totalPages}
                className='p-2'
              >
                &gt; {/* Right Arrow */}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}

export default Site
